import React from "react";

const NeueBulletListStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01961 4C4.01961 4.27614 3.79136 4.5 3.5098 4.5C3.22825 4.5 3 4.27614 3 4C3 3.72386 3.22825 3.5 3.5098 3.5C3.79136 3.5 4.01961 3.72386 4.01961 4Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01961 10C4.01961 10.2761 3.79136 10.5 3.5098 10.5C3.22825 10.5 3 10.2761 3 10C3 9.7239 3.22825 9.5 3.5098 9.5C3.79136 9.5 4.01961 9.7239 4.01961 10Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01961 16C4.01961 16.2761 3.79136 16.5 3.5098 16.5C3.22825 16.5 3 16.2761 3 16C3 15.7239 3.22825 15.5 3.5098 15.5C3.79136 15.5 4.01961 15.7239 4.01961 16Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4H17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10H17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 16H17",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueBulletListStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;